import { render, staticRenderFns } from "./nuevoPresupuesto.vue?vue&type=template&id=309f6f78&scoped=true"
import script from "./nuevoPresupuesto.vue?vue&type=script&lang=js"
export * from "./nuevoPresupuesto.vue?vue&type=script&lang=js"
import style0 from "./nuevoPresupuesto.vue?vue&type=style&index=0&id=309f6f78&prod&scoped=true&lang=css"
import style1 from "./nuevoPresupuesto.vue?vue&type=style&index=1&id=309f6f78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309f6f78",
  null
  
)

export default component.exports